import { render } from "./ApprovePR.vue?vue&type=template&id=b311390a"
import script from "./ApprovePR.vue?vue&type=script&lang=js"
export * from "./ApprovePR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__